// extracted by mini-css-extract-plugin
export default {"input":"TwoFactorCodeInput_input__GCO5J","divider":"TwoFactorCodeInput_divider__9qklE","invalid":"TwoFactorCodeInput_invalid__JtcKv","item":"TwoFactorCodeInput_item__nVwwc"};